<template>
  <div class="bg-transparent rounded-2px z-99 w-full h-full pt-10px relative">
    <div class="h-20/100">
      <div class="w-full">
        <CategoryTitle title="安防设备"></CategoryTitle>
        <div class="statisticsRate flex justify-between mt-10px">
          <div
            v-for="(item, index) in rateList"
            :key="index"
            class="w-31/100 flex flex-col justify-center reteItem cursor-pointer"
            @click="checkCameraList(item.name)"
          >
            <div :class="index === 0 ? 'one' : index === 1 ? 'two' : 'three'">{{ item.name }}</div>
            <div class="bottomBox">
              <div class="flex items-center h-40px p-8px totalBox">
                <!-- <span class="text-12px withe07">总数</span> -->
                <!-- 根据设备类型选择不同的加载方式，监控设备使用img标签 -->
                <div class="img-box" :class="item.img"></div>
                <span class="total-num ml-8px">{{ item.totalNum }}</span>
              </div>
              <div class="onLine flex justify-between items-center mt-10px">
                <div class="flex justify-start items-center">
                  <div class="onlineCircle"></div>
                  <span class="text-12px withe07 ml-5px">在线</span>
                </div>
                <div class="text-12px">{{ item.onlineNum }}</div>
              </div>
              <div class="offLine flex justify-between items-center mt-5px">
                <div class="flex justify-start items-center">
                  <div class="offlineCircle"></div>
                  <span class="text-12px withe07 ml-5px">离线</span>
                </div>
                <div class="text-12px">{{ item.offLineNum }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full h-25/100 mt-5px">
      <div class="flex justify-between items-center">
        <CategoryTitle title="全厂不安全报警"></CategoryTitle>
        <TableButtonGroup v-model="activeTab" :list="tabList" @btn-click="tabClick" />
      </div>
      <div class="h-[calc(100%-26px)]">
        <v-chart
          v-loading="chartLoading"
          :options="option"
          autoresize
          class="w-full h-full"
        ></v-chart>
      </div>
    </div>
    <div class="w-full h-55/100 overflow-hidden mt-10px">
      <div class="flex justify-between">
        <CategoryTitle title="安防报警"></CategoryTitle>
        <div class="flex">
          <TableButtonGroup
            v-model="securityActiveTab"
            :list="tabList"
            @btn-click="securityTabClick"
          />
        </div>
      </div>
      <div class="w-full h-[calc(100%-120px)]">
        <el-table
          ref="tableRef"
          height="100%"
          class="mt-4px"
          :data="detailList"
          highlight-current-row
          v-loading="warningLoading"
        >
          <el-table-column label="报警名称" prop="name" show-overflow-tooltip> </el-table-column>
          <el-table-column label="报警类型" prop="alarmTypeName" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            label="报警时间"
            prop="eventStartTime"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <el-pagination
          small
          background
          @current-change="getWarningList"
          :current-page.sync="pageInfo.pageNo"
          :page-size.sync="pageInfo.pageSize"
          layout="total, prev, pager, next"
          :total="pageInfo.total"
          class="text-center"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { includes, map } from 'lodash'
import dayjs from 'dayjs'
import { WisdomSecurityApi, WorkTicketApi } from '@wiz-api/huizhou2'
import { CockpitApi } from '@wiz-api/huizhou2-business'
import { StandardAlarmRecordApi, StandardAlarmSettingApi } from '@wiz-api/personnel-position'
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import TableButtonGroup from '@/components/cockpit/TableButtonGroup'

const wisdomSecurityApi = new WisdomSecurityApi()
const cockpitApi = new CockpitApi()

const alarmRecordApi = new StandardAlarmRecordApi()
const alarmSettingApi = new StandardAlarmSettingApi()

export default {
  components: {
    CategoryTitle,
    TableButtonGroup,
  },
  props: {
    player: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      alarmListVisible: false,
      activeTab: '日',
      securityActiveTab: '日',
      tabList: ['日', '月'],
      chartLoading: false,
      isShowDialog: false,
      warningLoading: false,
      rateList: [
        {
          img: 'device',
          name: '监控设备',
          totalNum: 124,
          onlineNum: 124,
          offLineNum: 0,
          percentage: 0,
        },
        {
          img: 'door',
          name: '门禁设备',
          totalNum: 6,
          onlineNum: 6,
          offLineNum: 0,
          percentage: 0,
        },
        {
          img: 'equipment',
          name: '道闸设备',
          totalNum: 3,
          onlineNum: 3,
          offLineNum: 0,
          percentage: 0,
        },
      ],
      option: {
        color: ['#45F2EB', '#3CD495', '#75C7FF', '#FEFF26'],
        tooltip: {
          trigger: 'item',
        },
        legend: {
          show: false,
        },
        series: [
          {
            type: 'pie',
            radius: [0, 60],
            center: ['50%', '50%'],
            data: [
              {
                name: '人数异常',
                value: 1,
              },
              {
                name: '未带安全帽',
                value: 3,
              },
              {
                name: '抽烟',
                value: 4,
              },
              {
                name: '带电话',
                value: 2,
              },
              {
                name: '违规翻越',
                value: 1,
              },
            ],
            label: {
              normal: {
                show: true,
                position: 'outside',
                formatter: '{b}: {c}',
                textStyle: {
                  color: 'rgba(255, 255, 255, 0.8)',
                  fontSize: 12,
                },
              },
            },
            labelLine: {
              normal: {
                show: true,
              },
            },
          },
        ],
      },
      detailList: [
        {
          name: '报警名称',
          alarmTypeName: '非法进入',
          eventStartTime: '2026-01-08 13:40:30',
        },
        {
          name: '报警名称',
          alarmTypeName: '非法离开',
          eventStartTime: '2026-01-07 17:30:20',
        },
        {
          name: '报警名称',
          alarmTypeName: '停留报警',
          eventStartTime: '2026-01-06 10:30:10',
        },
      ],
      pageInfo: {
        pageNo: 1,
        pageSize: 10,
        total: 3,
      },
      alarmTypeList: [],
    }
  },
  watch: {},
  computed: {},
  async created() {
    // 需要临时假数据暂时隐藏
    // await this.getAlarmTypeList()
    // await this.getSecurityDeviceStatsReport()
    // await this.getThreeDimensionalCount()
    // await this.getWarningList()
  },
  beforeDestroy() {},
  methods: {
    // 获取报警类型
    async getAlarmTypeList() {
      const [err, res] = await alarmSettingApi.getAlarmTypesFromSetting({ type: 0 })
      if (!err && res) {
        Object.keys(res).forEach((key) => {
          this.alarmTypeList.push({
            label: res[key],
            value: key,
          })
        })
      }
    },
    async getSecurityDeviceStatsReport() {
      const [err, res] = await wisdomSecurityApi.getSecurityDeviceStatsReport()
      if (!err && res && res.length) {
        res.forEach((item) => {
          this.rateList.forEach((it) => {
            if (includes(it.name, item.deviceName)) {
              it.totalNum = item.totalCount
              it.onlineNum = item.onLineCount
              it.offLineNum = item.offlineCount
              it.percentage = item.percentage
            }
          })
        })
      }
    },
    // 获取饼状图数据
    async getThreeDimensionalCount() {
      this.option.series[0].data = []
      // 遍历this.alarmTypeList根据value,获取值，根据值和label给this.option.series[0].data赋值
      this.alarmTypeList.forEach(async (item) => {
        const count = await this.getWarnListCount(item.value)
        this.option.series[0].data.push({
          name: item.label,
          value: count,
        })
      })
    },
    // 获取报警列表数值
    async getWarnListCount(type) {
      const startTime =
        this.activeTab === '日'
          ? dayjs()
              .startOf('day')
              .toISOString()
          : dayjs()
              .startOf('month')
              .toISOString()
      const endTime =
        this.activeTab === '日'
          ? dayjs()
              .endOf('day')
              .toISOString()
          : dayjs()
              .endOf('month')
              .toISOString()
      const [err, res] = await alarmRecordApi.getList({
        alarmType: type,
        startTime,
        endTime,
      })
      if (!err && res) {
        return res.totalCount
      }
      return 0
    },
    // 获取报警列表数据
    async getWarningList() {
      const startTime =
        this.securityActiveTab === '日'
          ? dayjs()
              .startOf('day')
              .toISOString()
          : dayjs()
              .startOf('month')
              .toISOString()
      const endTime =
        this.securityActiveTab === '日'
          ? dayjs()
              .endOf('day')
              .toISOString()
          : dayjs()
              .endOf('month')
              .toISOString()
      const [err, res] = await alarmRecordApi.getList({
        startTime,
        endTime,
        maxResultCount: this.pageInfo.pageSize,
        skipCount: (this.pageInfo.pageNo - 1) * this.pageInfo.pageSize,
      })
      if (!err && res) {
        this.detailList = map(res.items, (item) => {
          return {
            ...item,
            eventStartTime: item.eventStartTime
              ? dayjs(item.eventStartTime).format('YYYY-MM-DD HH:mm:ss')
              : item.eventStartTime,
            name: item.personNames + item.alarmTypeName + item.fenceName,
          }
        })
        this.pageInfo.total = res.totalCount
      }
    },
    async checkCameraList(name) {
      if (name === '监控设备') {
        this.$emit('transferEvent', {
          toCom: { code: 'CameraList', origin: '', name: '监控列表' },
          type: 'mainComponent',
          props: {},
        })
      } else if (name === '门禁设备') {
        this.$emit('transferEvent', {
          toCom: { code: 'AccessDoorControlGateList', origin: 'SmartSecurity', name: '门禁设备' },
          type: 'mainComponent',
          props: {},
        })
      } else if (name === '道闸设备') {
        this.$emit('transferEvent', {
          toCom: { code: 'AccessControlGateList', origin: 'SmartSecurity', name: '道闸设备' },
          type: 'mainComponent',
          props: {},
        })
      }
    },
    // 日月切换
    tabClick(val) {
      this.activeTab = val
      this.getThreeDimensionalCount()
    },
    securityTabClick(val) {
      this.securityActiveTab = val
      this.getWarningList()
    },
    checkAllAlarm() {
      this.isShowDialog = true
    },
  },
}
</script>
<style lang="scss" scoped>
.statisticsRate {
  color: #ffffff;
  text-shadow: 0px 0px 13.88px 0px #2f7eff72, 0px 3.08px 6.17px 0px #1da0e999;
  font-family: PangMenZhengDao;
  font-weight: regular;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 0px;
  text-align: center;
}
.device {
  background: url('../../../assets/images/smartSecurity/监控设备.png');
}
.door {
  background: url('../../../assets/images/smartSecurity/门禁道闸.png');
}
.equipment {
  background: url('../../../assets/images/smartSecurity/barriers-equipment.png');
}
.statisticsRate {
  .reteItem {
    .one {
      border-radius: 0.9px 0.9px 0px 0px;
      background: #53e0ff66;
      height: 27px;
      line-height: 27px;
    }
    .two {
      border-radius: 0.9px 0.9px 0px 0px;
      background: #59d4a08e;
      height: 27px;
      line-height: 27px;
    }
    .three {
      border-radius: 0.9px 0.9px 0px 0px;
      background: #c3c06c7f;
      height: 27px;
      line-height: 27px;
    }
    .bottomBox {
      border: 1px dotted rgba(255, 255, 255, 0.2);
      padding: 5px;
      .totalBox {
        border-radius: 0.9px;
        background: rgba(40, 163, 202, 0.1);

        /* 图片容器样式 */
        .img-box {
          width: 24px;
          height: 24px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
        }

        /* 直接img标签样式（备用） */
        .img-item {
          width: 24px;
          height: 24px;
          object-fit: contain;
        }

        /* 数量文本样式 */
        .total-num {
          font-size: 14px;
          color: #ffffff;
        }
      }
      .withe07 {
        color: rgba(255, 255, 255, 0.7);
      }
      .onlineCircle {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: rgba(13, 165, 55, 1);
      }
      .offlineCircle {
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background-color: rgba(148, 168, 217, 1);
      }
      .rateText {
        bottom: -5px;
        transform: scale(0.8);
      }
    }
  }
}
</style>
